import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["mappingSelect", "unresolvedBadge", "ratingToolSelect"];
  static values = { importId: Number };

  connect() {
    this.refreshUnresolvedCount();
    this.element.addEventListener("change", (event) => {
      if (event.target === this.ratingToolSelectTarget) return;
      this.refreshUnresolvedCount();
    });

    if (window.location.hash === "#legacy-tool-tab") {
      this.activateRatingToolTab();
    }
  }

  ratingToolChanged(event) {
    const toolId = event.target.value;
    if (!toolId || !this.hasImportIdValue) return;

    const url = `/admin/legacy_obe_spreadsheet_imports/${this.importIdValue}/edit?rating_tool_id=${toolId}#legacy-tool-tab`;
    window.location.assign(url);
  }

  activateRatingToolTab() {
    const tabLink = this.element.querySelector('a[href="#legacy-tool-tab"]');
    if (tabLink && window.jQuery) {
      window.jQuery(tabLink).tab("show");
    }
  }

  refreshUnresolvedCount() {
    if (!this.hasUnresolvedBadgeTarget) return;

    const unresolved = this.mappingSelectTargets.filter((select) => !select.value).length;
    this.unresolvedBadgeTarget.textContent = `${unresolved} unresolved`;
  }
}
